import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PasButtonComponent, PasSafeHtmlPipe } from '@porsche-aftersales/frontend-toolbox';

@Component({
  selector: 'tur-generic-modal-content',
  templateUrl: './generic-modal-content.component.html',
  styleUrls: ['./generic-modal-content.component.scss'],
  imports: [CommonModule, PasButtonComponent, PasSafeHtmlPipe],
})
export class GenericModalContentComponent {
  @Input() public modalTitle = '';
  @Input() public cancelButtonLbl = '';
  @Input() public acceptButtonLbl = '';
  @Input() public acceptanceAllowed = false;

  @Input() public icon: '' | 'info' | 'warn' | 'success' | 'danger';
  @Input() public confirmationMessage = '';
  @Input() public showCancelButton = true;

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() public cancel: EventEmitter<void> = new EventEmitter<void>();
  @Output() public confirm: EventEmitter<void> = new EventEmitter<void>();

  public onCancel(): void {
    this.cancel.emit();
  }

  public onConfirm(): void {
    this.confirm.emit();
  }
}
